import type { ConfigType } from '@plone/registry';
import { createElement, type HTMLAttributes, type ReactNode } from 'react';

import { medicalServicesSectionAlternation, quadreMedicFolderAlternation } from '../helpers/localizedSectionPath';

type SlateHeadingProps = {
  attributes?: HTMLAttributes<HTMLHeadingElement>;
  children?: ReactNode;
};

const Heading5 = ({ attributes, children }: SlateHeadingProps) =>
  createElement('h5', attributes, children);

const Heading6 = ({ attributes, children }: SlateHeadingProps) =>
  createElement('h6', attributes, children);

const CSJ_IMAGE_OBJECTS = [
  'Image',
  'imatge_slider_principal',
  'icona_rectificada_pagina_principal',
  'unitatespecialitzada',
];

export default function install(config: ConfigType) {
  config.settings.navDepth = 2;
  config.settings.supportedLanguages = ['ca', 'es', 'en'];
  config.settings.defaultLanguage = 'ca';
  config.settings.homepagePath = '';
  config.settings.homepageContentId = 'pagina-inicial';

  config.settings.imageObjects = [
    ...new Set([...(config.settings.imageObjects || []), ...CSJ_IMAGE_OBJECTS]),
  ];

  config.settings.slate = {
    ...config.settings.slate,
    elements: {
      ...config.settings.slate?.elements,
      h5: Heading5,
      h6: Heading6,
    },
  };

  const quadreMedicMetgeRoute = new RegExp(
    `/(${medicalServicesSectionAlternation})/(${quadreMedicFolderAlternation})/[^/]+$`,
  );

  config.settings.nonContentRoutes = [
    ...(config.settings.nonContentRoutes || []),
    quadreMedicMetgeRoute,
  ];
  config.settings.nonContentRoutesPublic = [
    ...(config.settings.nonContentRoutesPublic || []),
    quadreMedicMetgeRoute,
  ];

  return config;
}
